import { useState, useEffect, useCallback } from 'react';
import { getRequest } from '../api/ApiController';

/**
 * Zoznam typov údržby: donačítava sa z API (maintenance_types už nie sú v state pri logine).
 * @param {{ enabled?: boolean }} options - ak enabled === false, načítavanie sa nespustí (použitie napr. pri lazy taboch)
 * @returns {{ maintenanceTypes: Array, loading: boolean, refetch: function }}
 */
export function useMaintenanceTypes(options = {}) {
  const enabled = options.enabled !== false;
  const [maintenanceTypes, setMaintenanceTypes] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refetch = useCallback(() => {
    if (!enabled) return;
    setRefreshTrigger((t) => t + 1);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setMaintenanceTypes([]);
      return;
    }
    setLoading(true);
    getRequest('/api/maintenance_types?minimal=1')
      .then((r) => {
        const list = r?.data ?? r ?? [];
        setMaintenanceTypes(Array.isArray(list) ? list : []);
      })
      .catch(() => setMaintenanceTypes([]))
      .finally(() => setLoading(false));
  }, [enabled, refreshTrigger]);

  return { maintenanceTypes, loading, refetch };
}
